import {home} from '@/router/breadcrumbs';
import {PERMISSIONS} from '@/constants';

import ViewsErrors404 from '@/views/errors/ViewsErrors404.vue';
import ViewsHome from '@/views/home/ViewsHome.vue';
import ViewsMaintenance from '@/views/ViewsMaintenance.vue';
import ViewsSupport from '@/views/ViewsSupport.vue';
import {RouteRecordRaw} from 'vue-router';

export default [
    {
        path: '/',
        name: 'home',
        component: ViewsHome,
        meta: {
            requiresAuth: true,
            breadcrumbs: [{
                text: home.text
            }],
            permissions: [PERMISSIONS.EMPLOYEE]
        }
    },
    {
        path: '/maintenance',
        name: 'maintenance',
        component: ViewsMaintenance,
        meta: {}
    },
    {
        path: '/support',
        name: 'support',
        component: ViewsSupport,
        meta: {}
    },
    {
        path: '/:pathMatch(.*)*',
        component: ViewsErrors404
    }
] as RouteRecordRaw[]